const cities = {
    id: "cities",
    title: "Cityscapes",
    coverImage: "cities/cities.jpg",
    description: "City in motion.",
    order: 3,
    orientation: "landscape",

    images: [
        {
            src: "cities/IMG_0378.jpg",
            title: "Cycling is fun!",
            description: "Beijing"
        },
        {
            src: "cities/IMG_0609.jpg",
            title: "Public Transport",
            description: "Beijing"
        },
        {
            src: "cities/IMG_0900.jpg",
            title: "Food for the eye?",
            description: "Restaurant in Xi'An"
        },
        {
            src: "cities/IMG_0924.jpg",
            title: "A Billboard",
            description: "in Xi'An"
        },
        {
            src: "cities/IMG_0929.jpg",
            title: "A Chinese Lamp",
            description: "Streets of Beijing"
        },
        {
            src: "cities/IMG_0930.jpg",
            title: "Cyber Vibes",
            description: "Xi'An"
        },

        {
            src: "cities/IMG_0950.jpg",
            title: "A play of colors!",
            description: "Xi'An"
        }
        ,
        {
            src: "cities/IMG_0955.jpg",
            title: "A man gazes",
            description: "Lights of Xi'An"
        }
        ,
        {
            src: "cities/IMG_1055.jpg",
            title: "City Hustle",
            description: "Life in Chongqing"
        }
        ,
        {
            src: "cities/IMG_1082.jpg",
            title: "Night Time",
            description: "Skylines of Chongqing"
        }
    ]
};

export default cities;